import Booking from '@models/Booking'

export const getUnconfirmedBooking = () => {
  return Booking.query()
    .where('status', 'unconfirmed')
    .first()
}
